<template>
  <div class="stepView">
    <div class="stepView__step" :class="{'stepView__active': activeIndex === index }"
         v-for="(step, index) in steps"
         :key="step.id"
    >
      ШАГ {{ step.id }}: {{ step.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StepView",
  props: ["steps", "activeIndex"]
}
</script>

<style scoped lang="scss">
.stepView {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: var(--cd-default-font);
  font-weight: normal;
  color: var(--cd-text-muted);
  margin: 31px 0;

  &__active {
    color: var(--cd-highlight-text);
  }

}
</style>
